import React, { useState } from "react";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [sideBar, setSideBar] = useState(false);

  return (
    <div className="relative w-screen  top-0 sticky  z-50 ">
      <div className="border-1   bg-white flex items-center justify-between bg-slate-100 lg:px-4 py-1  lg:justify-around">
        <div className="logo m-5 flex justify-evenly space-x-6 lg:text-2xl text-xl font-medium">
          <img
            className="w-10"
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRtoau9Z1eBl7fVWNjzIRrFUMk31T3jpE8aZA1G3B_0rg&s"
            alt=""
          />
          <h1 className="font-bold">
            S.S.{" "}
            <a className="underline decoration-orange-700 decoration-4">
              {" "}
              PUBLIC{" "}
            </a>{" "}
            SCHOOL
          </h1>
        </div>

        <div
          className="hamburger md:hidden mr-2"
          onClick={() => {
            setSideBar(true);
          }}
        >
          <div className="line my-2 h-1 w-9 bg-black"></div>
          <div className="line my-2 h-1 w-9 bg-black"></div>
          <div className="line my-2 h-1 w-9 bg-black"></div>
        </div>

        <div className="first-heading hidden md:flex">
          <ul className="flex">
            <li className="home-nav-item head relative px-7 py-3 text-xl font-medium text-gray-800 hover:text-gray-400 lg:cursor-pointer">
              <div className="">
                <Link to={"/"}>Home</Link>&emsp;
              </div>
              <div className="home-dropdown z-50 bg-sky-50 absolute -left-6 top-12 hidden h-36 w-48 flex-col items-center justify-evenly border text-black shadow-lg">
                <a href="#about-school">About School</a>
                <a href="#values">Our Values</a>
                <a href="#history">Affiliation</a>
                <a href="#clip">Short gallery</a>

                <a href="#facility">Specialisation</a>
              </div>
            </li>

            <li className="home-nav-item head relative px-7 py-3 text-xl font-medium text-gray-800 hover:text-gray-400 lg:cursor-pointer">
              <div className="">
                <Link to={"/about"}>About</Link>&emsp;
              </div>

              <div className="home-dropdown z-50 bg-sky-50 absolute -left-6 top-12 hidden h-36 w-48 flex-col items-center justify-evenly border text-black shadow-lg">
                <a class="mx-6" href="#message">
                  From the Director's desk{" "}
                </a>
                <a href="#admission">Admission open</a>
                <a href="#act">Activity</a>
                <a href="#rating">Reviews</a>
              </div>
            </li>

            <li className="home-nav-item head relative px-7 py-3 text-xl font-medium text-gray-800 hover:text-gray-400 lg:cursor-pointer">
              <div className="">
                <Link to={"/gallery"}>Gallery</Link>&emsp;
              </div>
              <div className="home-dropdown z-50 bg-sky-50 absolute -left-6 top-12 hidden h-36 w-48 flex-col items-center justify-evenly border text-black shadow-lg">
                <a href="#photo">Photo Gallery</a>
                <a href="#media">Media Gallery</a>
                {/* <a href="#video">Video Gallery</a> */}

                <a href="#classwise">Playclass Gallery</a>
              </div>
            </li>

            <li className="home-nav-item head relative px-7 py-3 text-xl font-medium text-gray-800 hover:text-gray-400 lg:cursor-pointer">
              <div className="">
                <Link to={"/syllabus"}>Syllabus</Link>&emsp;
              </div>
              {/* <div className="home-dropdown z-50 bg-sky-50 absolute -left-6 top-12 hidden h-36 w-48 flex-col items-center justify-evenly border text-black shadow-lg">
                <a href="#photo">Photo Gallery</a>
                <a href="#media">Media Gallery</a>
                <a href="#video">Video Gallery</a>

                <a href="#classwise">Playclass Gallery</a>
              </div> */}
            </li>

            <li className="home-nav-item head relative px-7 py-3 text-xl font-medium text-gray-800 hover:text-gray-400 lg:cursor-pointer">
              <div className="">
                <Link to={"/achievement"}>Achievements</Link>&emsp;
              </div>
              <div className="home-dropdown z-50 bg-sky-50 absolute -left-6 top-12 hidden h-36 w-48 flex-col items-center justify-evenly border text-black shadow-lg">
                <a href="#prize"> Awards</a>
                <a href="#score">Score board(result)</a>
                {/* <>Facility</> */}
              </div>
            </li>

            <li className="home-nav-item head relative px-7 py-3 text-xl font-medium text-gray-800 hover:text-gray-400 lg:cursor-pointer">
              <div className="">
                <Link to={"/service"}>Service</Link>&emsp;
              </div>
              <div className="home-dropdown z-50 bg-sky-50 absolute -left-6 top-12 hidden h-36 w-48 flex-col items-center justify-evenly border text-black shadow-lg">
                <a href="#headlines">News</a>
                <a href="#why">Why choose us</a>
                <a href="#guidelines">Rules</a>
                <a href="#pros">Uniform</a>
              </div>
            </li>
            <li className="home-nav-item head relative px-7 py-3 text-xl font-medium text-gray-800 hover:text-gray-400 lg:cursor-pointer">
              <div className="">
                <Link to={"/contact"}>Contact</Link>
              </div>
              <div className="home-dropdown z-50 bg-sky-50 absolute -left-6 top-12 hidden h-36 w-48 flex-col items-center justify-evenly border text-black shadow-lg">
                <a href="#mail">Mail us</a>
                <a href="#location">Map</a>
                {/* <div>Home4</div> */}
              </div>
            </li>
          </ul>
        </div>

        <div
          className={`sidebar duration-500 transition-all bg-white ${
            sideBar === true ? "" : "hidden"
          } lg:hidden h-screen fixed w-[60%] top-0 right-0`}
        >
          <div
            className="text-2xl text-black float-right m-3"
            onClick={() => {
              setSideBar(false);
            }}
          >
            X
          </div>
          <ul className="flex flex-col">
            <li className="home-nav-item head relative px-7 py-3 text-xl font-medium text-gray-800 hover:bg-sky-400 lg:cursor-pointer">
              <div className="">
                <Link to={"/home"}>Home</Link>
              </div>
              <div className="home-dropdown z-50 bg-white absolute -left-40 top-6 hidden h-32 w-44 flex-col items-center justify-evenly border text-black shadow-lg">
                <div>About school</div>
                <div>Our values</div>
                <div>Affiliation</div>
                <div>Short gallery</div>
                <div>Specialisation</div>
              </div>
            </li>

            <li className="home-nav-item head relative px-7 py-3 text-xl font-medium text-gray-800 hover:bg-sky-400 lg:cursor-pointer">
              <div className="">
                <Link to={"/about"}>About</Link>
              </div>

              <div className="home-dropdown z-50 bg-white absolute -left-40 top-6 hidden h-32 w-44 flex-col items-center justify-evenly border text-black shadow-lg">
                <div>From the Director's desk </div>
                <div>Admission open</div>
                <div>Activity</div>
                <div>Reviews</div>
              </div>
            </li>

            <li className="home-nav-item head relative px-7 py-3 text-xl font-medium text-gray-800 hover:bg-sky-400 lg:cursor-pointer">
              <div className="">
                <Link to={"/gallery"}>Gallery</Link>
              </div>
              <div className="home-dropdown z-50 bg-white absolute -left-40 top-6 hidden h-32 w-44 flex-col items-center justify-evenly border text-black shadow-lg">
                <div>Photo Gallery</div>
                <div>Media Gallery</div>
                {/* <div>Video Gallery</div> */}

                <div> Classwise Gallery</div>
              </div>
            </li>

            <li className="home-nav-item head relative px-7 py-3 text-xl font-medium text-gray-800 hover:bg-sky-400 lg:cursor-pointer">
              <div className="">
                <Link to={"/syllabus"}>Syllabus</Link>
              </div>
              </li>


            <li className="home-nav-item head relative px-7 py-3 text-xl font-medium text-gray-800 hover:bg-sky-400 lg:cursor-pointer">
              <div className="">
                <Link to={"/achievement"}>Achievements</Link>
              </div>
              <div className="home-dropdown z-50 bg-white absolute -left-40 top-6 hidden h-32 w-44 flex-col items-center justify-evenly border text-black shadow-lg">
                <div>Awards</div>
                <div>Score board(result)</div>
              </div>
            </li>

            <li className="home-nav-item head relative px-7 py-3 text-xl font-medium text-gray-800 hover:bg-sky-400 lg:cursor-pointer">
              <div className="">
                <Link to={"/service"}>Service</Link>
              </div>
              <div className="home-dropdown z-50 bg-white absolute -left-40 top-6 hidden h-32 w-44 flex-col items-center justify-evenly border text-black shadow-lg">
                <div>News</div>
                <div>Why choose us</div>
                <div>Rules</div>
                <div>Uniform</div>
              </div>
            </li>
            <li className="home-nav-item head relative px-7 py-3 text-xl font-medium text-gray-800 hover:bg-sky-400 lg:cursor-pointer">
              <div className="">
                <Link to={"/contact"}>Contact</Link>
              </div>
              <div className="home-dropdown z-50 bg-white absolute -left-40 top-6 hidden h-32 w-44 flex-col items-center justify-evenly border text-black shadow-lg">
                <div>Mail us</div>
                <div>Map</div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
